@if (displayHtmlErrors) {
  <div [id]="id + '-form-errors'">
    <span class="font-semibold form-error">Please fix form errors.</span>
    @if (formErrors?.length > 0) {
      <div>
        @for (formError of formErrors; track formError[0]) {
          <div>
            <div (click)="jumpTo(formError[0])" style="cursor: pointer">
              <s-form-error-message>
                <i inline>find_in_page</i>{{ formError[1] }} -
                {{ formError[2] }}
              </s-form-error-message>
            </div>
          </div>
        }
      </div>
    }
  </div>
}
<div>
  @if (apiError?.message) {
    <s-form-error-message>
      <s-form-error-message class="error-message preserve-format">
        {{ apiError.message }}
      </s-form-error-message>
    </s-form-error-message>
  }
</div>
